<template>
  <div>
    <router-view />
    <TheSnackbar />
    <TheModalConfirmation ref="modalConfirmation" />
    <TheSessionExpiredDialog />
  </div>
</template>

<script>
import TheSnackbar from "@/components/common/TheSnackbar";
import TheModalConfirmation from "@/components/common/TheModalConfirmation";
import TheSessionExpiredDialog from "@/components/common/TheSessionExpiredDialog";
export default {
  components: {
    TheSnackbar,
    TheModalConfirmation,
    TheSessionExpiredDialog,
  },
  name: "App",
  mounted() {
    this.$root.$modalConfirmation = this.$refs.modalConfirmation.open;
  },
};
</script>
